"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;

var _Flag = _interopRequireDefault(require("./Flag"));

exports.default = _Flag.default;


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/commonjs/elements/Flag/index.js
// module id = 320
// module chunks = 0